import { useP2GInView } from '@parcel2go/core-ui';

export interface props {
  override?: boolean;
  placeholder?: React.ReactNode;
  children: React.ReactNode;
}

const ShowInView: React.FC<props> = (props) => {
  const [ref, inView] = useP2GInView({
    triggerOnce: true
  });

  if (inView || props.override) {
    return <>{props.children}</>;
  }

  return <div ref={ref}>{props.placeholder}</div>;
};
export default ShowInView;
